<template>
  <page style="z-index: 999">
    <div class="detail-page" v-if="goodsInfo">
      <div class="swiper-box">
        <van-swipe :autoplay="3000" indicator-color="#FF3400">
          <van-swipe-item v-for="(image, index) in bannerImg" :key="index">
            <img :src="image" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="goods-container">
        <div class="goods-title-ms" v-if="goodsInfoType === 'miaosha' || goodsInfoType === 'tejia'">
          <div class="skillContent">
            <img v-if="goodsInfoType === 'miaosha'" src="@/assets/ms_bg.png" class="image_bg" />
            <img
              v-else
              src="https://img2.coocaa.com/ui/partner-mini-program/tejiaBg.png"
              class="image_bg"
            />
            <div class="skillItem">
              <div class="price-box">
                <span class="discountBefore">¥</span>
                <span class="discount" v-if="skillPrice">
                  {{ Number(skillPrice || 0).toFixed(2) }}
                </span>
                <span class="discount" v-else>
                  {{ Number(goodsInfo.sellPrice || 0).toFixed(2) }}
                </span>
                <span class="price">¥{{ Number(goodsInfo.marketPrice || 0).toFixed(2) }}</span>
              </div>
              <div class="skillTime">
                <div class="skillTime_title">{{ skillTitle }}</div>
                <van-count-down
                  ref="countDownTime"
                  :time="startTime"
                  use-slot
                  class="countDownTime"
                  @change="timeChange"
                >
                  <template #default="timeData">
                    <!-- <span class="item" v-if="timeData.days">{{ timeData.days }}</span><i style="color: #fff;display:inline-block;">:</i> -->
                    <span
                      class=""
                      style="color: #fff; display: inline-block; font-size: 12px"
                      v-if="timeData.days"
                    >
                      {{ timeData.days }}
                    </span>
                    <i
                      v-if="timeData.days"
                      style="color: #fff; display: inline-block; font-size: 12px"
                    >
                      天
                    </i>
                    <span class="item">
                      {{ timeData.hours > 9 ? timeData.hours : '0' + timeData.hours }}
                    </span>
                    <i style="color: #fff; display: inline-block">:</i>
                    <span class="item">
                      {{ timeData.minutes > 9 ? timeData.minutes : '0' + timeData.minutes }}
                    </span>
                    <i style="color: #fff; display: inline-block">:</i>
                    <span class="item">
                      {{ timeData.seconds > 9 ? timeData.seconds : '0' + timeData.seconds }}
                    </span>
                  </template>
                </van-count-down>
              </div>
            </div>
          </div>
          <div class="title">
            {{ goodsInfo.title }}
          </div>
          <div class="sub-title">
            {{ goodsInfo.subTitle }}
          </div>
          <!-- <div style="width: 100%; height: 30px; background: #fff"></div> -->
        </div>
        <div class="goods-title cf">
          <div class="price-box cf">
            <template>
              <span class="active-price">
                ¥{{ Number(goodsInfo.__actPrice || goodsInfo.sellPrice).toFixed(2) }}
              </span>
              <span class="price">¥{{ Number(goodsInfo.marketPrice).toFixed(2) }}</span>
            </template>
            <span class="tips" v-if="goodsInfo.spuType === 1">运费：{{ freightDesc }}</span>
          </div>
          <h3 class="title">{{ goodsInfo.title }}</h3>
          <h4 class="subTitle" v-if="goodsInfo.goodsDetailAds">
            {{ goodsInfo.goodsDetailAds }}
          </h4>
        </div>
        <!-- <h1 @click="clickTest">测试测试测试</h1> -->
        <div class="bonusList" v-if="bonusList.length > 0">
          <span class="lefttitle">优惠</span>
          <div class="centerList">
            <div class="text" v-for="(item, index) in bonusList" :key="index">
              <span v-if="item.actType == 0">{{ item.couponVO.couponInfo.couponName }}</span>
              <span v-else>{{ item.actPromotion.actTag || item.actPromotion.actName }}</span>
            </div>
          </div>
          <!-- <div class="rightIcon" @click="clickBonusPop">
            <img class="image" src="https://img2.coocaa.com/addr.png" />
          </div> -->
        </div>

        <ul class="goods-message">
          <van-cell title="规格" v-if="isShiWu" :value="goodsModelText"></van-cell>
          <van-cell title="服务说明" :value="goodsInfo.supportNoReason ? '7天无理由退货' : ''" />
          <van-cell title="发货" is-link value="不发货地区" @click="getNoAreas" />
        </ul>

        <div class="goods-introduce">
          <van-divider>图文详情</van-divider>
          <div class="img-detail" v-if="imgInfo">
            <img
              v-for="(item, index) in imgInfo"
              :key="index"
              :src="item"
              mode="widthFix"
              alt=""
              style="width: 100%"
            />
          </div>
          <div class="nothing color-999" v-else>暂无内容</div>
        </div>
      </div>
      <van-popup v-model="bonusPop" title="优惠券" position="bottom" :style="{ height: '60%' }">
        <div class="bonus-pop">
          <div class="closeBtn">
            <img src="@/assets/close.png" alt="" @click="bonusPop = false" />
          </div>
          <div class="pop_title">优惠信息</div>
          <div class="list" v-if="preferentialList.length">
            <div class="item" v-for="(item, index) in preferentialList" :key="index">
              <div v-if="item.actType" style="width: 90%">
                <div class="left_con">
                  <div class="title">
                    {{ item.actPromotion.discountInfoTitle || item.actPromotion.actName }}
                  </div>
                  <div class="desc">
                    {{ item.actPromotion.discountInfoDesc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="coupon" v-if="couponList.length">
            <div class="h4">可领优惠券</div>
            <div class="couponList">
              <div v-for="(item, index) in couponList" :key="index">
                <div v-if="item.actType === 0" class="item">
                  <div class="con leftPrice">
                    <h4>
                      <span>￥</span>
                      {{ item.couponVO.couponInfo.mainNumber }}
                    </h4>
                    <p>
                      {{ item.couponVO.couponInfo.limitText }}
                    </p>
                  </div>
                  <div class="con centerCon">
                    <p class="title">
                      {{ item.couponVO.couponInfo.couponName }}
                    </p>
                    <p class="time">
                      {{ item.couponVO.couponInfo.validPeriod }}
                    </p>
                  </div>
                  <div class="con rightBtn">
                    <span v-if="item.couponVO.receiveStatus === 'no'" @click="sendBonus(item)">
                      领取
                    </span>
                    <span class="toDetailList" v-else>已领取</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
      <van-popup
        v-model="sharePicPop"
        :style="{ 'border-radius': isShareCollage ? '10px' : '0' }"
        @close="isShareCollage = false"
      >
        <img :src="sharePic" alt="" class="shareImg" />
      </van-popup>
      <van-popup
        v-model="nShipAdd"
        title="不发货地区"
        position="bottom"
        round
        :style="{ height: '60%' }"
      >
        <div class="pop_title">不发货地区</div>
        <div class="addressAreas" v-for="item in nonsupportShippingAreas" :key="item.id">
          {{ item.provinceName }}
        </div>
      </van-popup>
      <van-popup v-model="showPop" position="bottom" :style="{ height: '30%' }">
        <ShareComponent
          @weChatCollage="beforeweChatCollage"
          @shareCollage="beforeShareCollage"
        ></ShareComponent>
      </van-popup>
      <ShareRightTopMessage :showShare.sync="showShare"></ShareRightTopMessage>
      <!-- <van-icon name="like-o" class="share-icon" /> -->
      <detail
        ref="footerDetail"
        :isShiWu="isShiWu"
        :groupCode="groupCode"
        :default-obj="goodsInfo"
        :activityInfo="bonusList"
        :collageStatus="collageStatus"
        :goodsNumber="goodsInfo.stockNumber"
        :typeBuy="buyType"
        :actCode="actCode"
        :maxCartNumber="maxCartNumber"
        :act-type="goodsInfoType"
        @collageChangeNum="collageChangeNum"
        @changeTap="refreshPage"
      ></detail>
    </div>
    <!-- <popup pageFrom="goodsDetail"></popup> -->
    <!-- dialog里也有倒计时结束的,此时需要通过finish反馈给这里 刷新groupbuylist -->
    <!-- <PopDialog
      @finish="childFinish(item)"
      :groupList="groupBuyListAll"
      @collage="clickCollage"
      @close="showCollage = false"
      v-show="showCollage"
    ></PopDialog> -->
  </page>
</template>
<script>
// import popup from '@/views/ShoppingMall/popup.vue'
import detail from '@/components/detail/index.vue';
// import PopDialog from '@/views/ShoppingMall/Collage/PopDialog.vue'

import ShareComponent from '@/views/ShoppingMall/ShareComponent.vue';
// import CollageGoodsDetailsOnly from '@/views/ShoppingMall/Collage/CollageGoodsDetailsOnly.js'
import collageBase from '@/views/ShoppingMall/collageBase.js';
import { Toast } from 'vant';

import ShareRightTopMessage from '@/components/ShareRightTopMessage.vue';
import { handlerActGoodsPrice } from '../../../modules/common';

export default {
  mixins: [collageBase],
  components: {
    ShareComponent,
    ShareRightTopMessage,
    detail
    // PopDialog
  },
  computed: {
    goodsGroupBuyList() {
      let arr = this.groupBuyListAll.filter((item) => !item.finish);
      arr.splice(2);
      return arr;
    },
    // showSelectNum () {
    //   let isCollage = this.openCollage && this.collageStatus == '进行中'
    //   return !isCollage && this.isShiWu
    // },
    isShiWu() {
      return this.goodsInfo.spuType === 1;
    },
    ccLogParams() {
      return {
        // commodity_id: this.getGoodsData.skuId,
        // commodity_name: this.getGoodsData.title,
        // goods_price: this.getGoodsData.sellPrice,
        // original_price: this.getGoodsData.marketPrice,
        // commodity_type: this.getGoodsData.spuType,
        user_empNo: this.getEmpNo || '',
        frontPageName: this.getFromUrl,
        page_name: '商品详情'
      };
    },
    goodsPrice() {
      return this.skillPrice || this.goodsInfo.sellPrice;
    }
  },
  data() {
    return {
      showCollage: false,
      goodsLink: location.origin,
      isBonus: false,
      goodsId: '',
      // rebateValue: 0,
      bonusPop: false,
      showPop: false,
      sharePicPop: false,
      type: 1,
      empNo: null,
      empInfo: {},
      maxCartNumber: 999,
      imgLisg: '',
      bannerImg: [],
      imgInfo: '',
      bonusList: [],
      dtoList: {},
      bonusTypeDTO: {
        bonusTypeDTO: {}
      },
      actPromotion: [],
      sharePic: '',
      url: '',
      preferentialList: [], // 优惠信息列表
      couponList: [], // 优惠券列表
      buyType: 'buy', // 秒杀 or 普通购买
      skillPrice: 0,
      goodsInfoType: '',
      goodsInfo: {},
      timeData: {},
      startTime: 0,
      actCode: '',
      collageStatus: '',
      nShipAdd: false,
      nonsupportShippingAreas: [],
      goodsModelText: '标准',
      freightDesc: 0, // 运费
      isShareCollage: false
    };
  },
  methods: {
    getShareLink() {
      this.goodsLink = `${location.origin}/goodsDetail?goodsId=${this.goodsInfo.skuId}`;
      let link;
      const fromCode = this.empInfo.applyId || this.empInfo.empNo;
      if (fromCode) {
        link = `${location.origin}/ad-link/ccfx?pageType=employee&target=${encodeURIComponent(
          this.goodsLink
        )}&fromCode=${fromCode}`;
      } else {
        link = location.href;
      }
      console.log('分享连接', link);
      return link;
    },
    refreshPage(data) {
      this.goodsId = data.goodsId;
      this.goodsModelText = '已选：' + data.goodsModel;
      this.init();
    },
    init() {
      let promise2 = this.getGoodsBonus();
      let promise3 = this.goodsDetail();
      // let promise4 = this.getGoodsGroupBuyList(this.goodsId)
      // 从我要参团界面跳入后要马上操作支付
      // this.needAutoPay = this.$route.query.fromCollage === 1
      Promise.all([promise2, promise3]);
    },
    goodsDetail() {
      return this.$service
        .getGoodsDetails({
          skuId: this.goodsId
        })
        .then((res) => {
          console.log('获取商品详情', res);
          const data = res.data;
          this.goodsInfo = data;

          if (this.goodsInfo.actInfos && this.goodsInfo.actInfos.length) {
            this.goodsInfo = handlerActGoodsPrice([this.goodsInfo])[0];
          }

          if (this.goodsInfo.shippingInfo) {
            this.freightDesc = this.goodsInfo.shippingInfo.freightDesc;
          }
          this.imgInfo = data.details;
          const goodsNumber = data.stockNumber;
          if (goodsNumber < 999) {
            this.maxCartNumber = goodsNumber;
          }
          this.bannerImg = data.bannerList;
          // if (this.empNo) {
          //   this.getEmpGoodsRebate(data)
          // }
          // 商详页面view曝光
          this.$constants.submitccLog('partner_mini_page_show', '商详页面曝光', {
            ...this.ccLogParams
          });
          this.$wxSdk({
            title: data.title,
            desc: data.subTitle,
            link: this.getShareLink(),
            imgUrl: data.skuThumb
          });
        });
    },
    async beforeweChatCollage() {
      let arr = this.getFromUrl.split(',');
      arr.push('分享-微信好友');
      this.$constants.submitccLog(
        'partner_mini_page_click',
        '点击商品详情页分享---“微信好友”Button',
        {
          ...this.ccLogParams,
          frontPageName: arr.join(','),
          button_name: '分享-微信好友'
        }
      );
      await this.createGroup();
      this.weChatCollage();
    },
    async beforeShareCollage() {
      let arr = this.getFromUrl.split(',');
      arr.push('分享-生成海报');
      this.$constants.submitccLog(
        'partner_mini_page_click',
        '点击商品详情页分享---“生成海报”Button',
        {
          ...this.ccLogParams,
          frontPageName: arr.join(','),
          button_name: '分享-生成海报'
        }
      );
      this.isShareCollage = true;
      let groupInfo = await this.createGroup();
      this.shareCollage(
        groupInfo.expireTime,
        groupInfo.groupCode,
        groupInfo.groupNum - groupInfo.joinNum
      );
    },
    collageChangeNum(value) {
      this.goodsInfo.number = value;
    },
    // async getGoodsGroupBuyList (goodsId) {
    //   const params = {
    //     goodsId
    //   }
    //   const res = await this.$service.getGoodsGroupBuyList(params)
    //   this.groupBuyListAll = res.data.map((item, index) => {
    //     let lastTime = item.expireTime - Date.now()
    //     return {
    //       ...item,
    //       finish: item.status == 2 || lastTime <= 0,
    //       lastNum: item.groupNum - item.joinNum,
    //       lastTime: lastTime < 0 ? 0 : lastTime
    //     }
    //   })
    //   this.groupBuyListAll = this.groupBuyListAll.filter(item => !item.finish)
    // },
    getGoodsBonus() {
      this.preferentialList = [];
      this.couponList = [];
      this.bonusPop = false;
      this.skillPrice = 0;
      return this.$service
        .getGoodsBonus({
          goodsId: this.goodsId
        })
        .then((res) => {
          const data = res.data;
          if (data.length) {
            this.isBonus = true;
            this.bonusList = data;
            data.forEach((element) => {
              // 秒杀和拼团不会同时存在,直接复用
              if (element.actType === 0) {
                return;
              }
              if (element.actType === 5 || element.actType === 4) {
                this.actCode = element.actPromotion.actCode;
                // actType  0为优惠券, 1-满几件几折, 2-满多少减多少, 3-积分, 4-降价, 5-秒杀
                if (element.actType === 4) {
                  this.goodsInfoType = 'tejia';
                } else {
                  this.goodsInfoType = 'miaosha';
                }
                console.log('goodsInfoType', this.goodsInfoType);
                let nowDate = +new Date();
                if (nowDate < element.actPromotion.startTime * 1000) {
                  // 未开始
                  this.skillTitle = '距离开始仅剩';
                  this.startTime = element.actPromotion.startTime * 1000 - nowDate;
                  console.log('活动', this.skillTitle, this.startTime);
                } else if (
                  nowDate > element.actPromotion.startTime * 1000 &&
                  nowDate < element.actPromotion.endTime * 1000
                ) {
                  // 进行中
                  this.skillTitle = '距离结束仅剩';
                  if (element.actType === 5) {
                    this.buyType = 'skill';
                  } else if (element.actType === 4) {
                    this.buyType = 'tejia';
                  }
                  this.startTime = element.actPromotion.endTime * 1000 - nowDate;
                  console.log('活动进行中', this.skillTitle, this.startTime);
                  let skArr = element.actPromotion.actPromotionGoodsDtoList;
                  skArr.forEach((item) => {
                    if (item.goodsId == this.goodsId) {
                      this.skillPrice = item.actPrice;
                    }
                  });
                } else {
                  // 已结束
                  this.startTime = 0;
                  this.goodsInfoType = '';
                  console.log('活动结束', this.startTime);
                  this.getGoodsBonus();
                  this.goodsDetail();
                }
              } else if (element.actType === 22) {
                this.goodsInfoType = 'dengji'
              } else {
                this.goodsInfoType = '';
              }
              if (element.actType) {
                this.preferentialList.push(element);
              } else {
                this.couponList.push(element);
              }
            });
          }

          // 从我要参团界面跳入后要马上操作支付
          // if (this.needAutoPay) {
          //   this.needAutoPay = false
          //   this.$nextTick(res => {
          //     console.log(
          //       '从我要参团界面跳入后要马上操作支付 actCode',
          //       this.actCode
          //     )
          //     this.clickPintuan({
          //       groupCode: this.$route.query.groupCode,
          //       actCode: this.actCode
          //     })
          //   })
          // }
        });
    },
    // 领取优惠券
    sendBonus(data) {
      this.$service
        .sendBonusType({
          couponId: data.couponVO.couponInfo.couponId,
          sourceType: data.couponVO.couponInfo.sourceType || '2',
          sourceData: data.couponVO.couponInfo.sourceData || '未知'
        })
        .then((res) => {
          this.getGoodsBonus();
          Toast({
            message: '领取成功'
          });
        });
    },

    timeChange(e) {
      // 这个其实没用!人家那个timeData是作用域插槽,和这里的全局属性timeData不是同一个东西
      this.timeData = e.detail;
    },
    // 获取店铺/商品不发货地区列表
    getNoAreas() {
      this.$service
        .getNonsupportShippingAreas({
          skuId: this.goodsInfo.skuId
        })
        .then((res) => {
          this.nShipAdd = true;
          this.nonsupportShippingAreas = res.data;
        });
    }
  },
  mounted() {
    this.goodsId = this.$route.query.goodsId;
    if (!this.goodsId) {
      this.$router.push('/store-home');
      return;
    }
    this.init();
  }
};
</script>

<style scoped lang="stylus">
@import './goodsDetail.css'
@import './goodsDetail.styl'
.pop_title {
    text-align: center;
    color: #000000;
    font-size: 14px;
    padding-top: 16px;
  }
  .addressAreas {
    margin: 8px 16px
    font-size: 12px
  }
</style>
